export enum SkuWebComponent {
    LabelTitle = "label-title",
    LabelTicket = "label-ticket",
    InputHidden = "input-hidden",
    InputTextWithConfirmation = "input-text-with-confirmation",
    InputTextWithConfirmationUppercase = "input-text-with-confirmation-uppercase",
    SelectAmount = "select-amount",
    SelectAmountWithDetail = "select-amount-with-detail",
    MessageInfo = "message-info",
    MessageInfoTicket = "message-info-ticket",
    MessageError = "message-error",
    ActionOk = "action-ok",
    ActionCancel = "action-cancel",
    MessageWarn = "message-warn",
    InputAmountReceipt = "input-amount-receipt",
    InputAmount = "input-amount",
    //[Balance Step 9]: Enum que identifica el componente encargado de mostrar el saldo del cliente (SkuClientBalance).
    BalanceInfo = "input-client-balance",
    
    // Componente específico para códigos QR
    InputQR = "input-qr",

    // Componente para mostrar información de activación QR
    ActivationInfo = "activation-info",

    None = ""
}